// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-32ee9fbc] .el-pagination.is-background .el-pager li:not(.disabled).active{background-color:#97d700;color:#fff}.el-tag.el-tag--info[data-v-32ee9fbc],.el-tag.el-tag--warning[data-v-32ee9fbc]{border-color:#f0f9eb!important;border-radius:25px}.pagination-wrapper[data-v-32ee9fbc]{margin:1em 0}", ""]);
// Exports
module.exports = exports;
